// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueReservationsEnCours = (newValue) => ({
  type: actionTypes.SET_VALUE_RESERVATION_EN_COURS,
  payload: newValue,
});

export const setCurrentPageReservationsEnCours = (newCurrentPage) => ({
  type: actionTypes.SET_CURRENT_PAGE_RESERVATION_EN_COURS,
  payload: newCurrentPage,
});

export const setSortingReservationsEnCours = (newSorting) => ({
  type: actionTypes.SET_SORTING_RESERVATION_EN_COURS,
  payload: newSorting,
});
export const setPageSizeReservationsEnCours = (newValue) => ({
  type: actionTypes.SET_PAGE_SIZE_RESERVATION_EN_COURS,
  payload: newValue,
});

export const setCustomFilterReservationsEnCours = (newValue) => ({
  type: actionTypes.SET_CUSTOM_FILTERS_RESERVATION_EN_COURS,
  payload: newValue,
});
export const setSortFieldReservationsEnCours = (newSortField) => ({
  type: actionTypes.SET_SORT_FIELD_RESERVATION_EN_COURS,
  payload: newSortField,
});
export const setOrderReservationsEnCours = (newOrder) => ({
  type: actionTypes.SET_ORDER_RESERVATION_EN_COURS,
  payload: newOrder,
});
export const setActiveTabReservationsEnCours = (newActiveTab) => ({
  type: actionTypes.SET_ACTIVE_TAB_RESERVATION_EN_COURS,
  payload: newActiveTab,
});
export const setQueryReservationsEnCours = (newQuery) => ({
  type: actionTypes.SET_QUERY_RESERVATION_EN_COURS,
  payload: newQuery,
});
export const setActifReservationsEnCours = (newQuery) => ({
  type: actionTypes.SET_ACTIF_RESERVATION_EN_COURS,
  payload: newQuery,
});
export const setSelectedOptionFiltersReservationsEnCours = (newQuery) => ({
  type: actionTypes.SET_SELECTED_OPTION_FILTERS_RESERVATION_EN_COURS,
  payload: newQuery,
});
export const setSelectedOptionIdReservationsEnCours = (newQuery) => ({
  type: actionTypes.SET_SELECTED_OPTION_ID_RESERVATION_EN_COURS,
  payload: newQuery,
});

export const setColumnReservationsEnCours = (newValue) => ({
  type: actionTypes.SET_COLUMN_RESERVATION_EN_COURS,
  payload: newValue,
});
